// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

// The "thinking" line while an agent turn runs. The REAL step is the server-polled `status` (the tool
// Khora is actually running right now), shown verbatim. Before the first tool call — or in the gap
// between polls — there is no real step yet, so we show a single neutral "working" line rather than a
// made-up specific action. That way every CONCRETE step the user sees is one that is actually
// happening; the bouncing dots (not a fake action list) carry the "still alive" feel.
interface ThinkingIndicatorProps {
  styles: Record<string, SxProps<Theme>>;
  // Live status polled from the server; null before the first tool call or if S3 progress is off.
  status: string | null;
}

const ThinkingIndicator: FC<ThinkingIndicatorProps> = ({ styles, status }) => {
  const text = status || 'Khora is working…';

  return (
    <Box sx={styles.thinking}>
      <Box sx={styles.thinkingDots}>
        <Box sx={styles.thinkingDot} />
        <Box sx={styles.thinkingDot} />
        <Box sx={styles.thinkingDot} />
      </Box>
      <Typography sx={styles.thinkingText}>{text}</Typography>
    </Box>
  );
};

export default ThinkingIndicator;
